import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVICE_TOKEN_FACTORY } from './token.service';

export const SERVICE_TOKEN = new InjectionToken<ITokenService>('SERVICE_TOKEN', {
  providedIn: 'root',
  factory: SERVICE_TOKEN_FACTORY,
});

/**
 * トークン情報
 */
export interface ITokenModel {
  /**
   * アクセストークン
   */
  accessToken: string;
  /**
   * アクセストークンの有効期限（秒単位）
   */
  expiresIn: number;
}

/**
 * リクエスト元のURL
 */
export interface AuthReferrer {
  url?: string | null | undefined;
}

export interface ITokenService {
  /**
   * アクセス権限がないときの遷移先
   */
  readonly login_url: string | undefined;

  /**
   * リクエスト元のURL
   */
  readonly referrer?: AuthReferrer;

  /**
   * タイマーによるトークンを自動的にリフレッシュ
   */
  readonly refresh: Observable<ITokenModel>;

  /**
   * トークン情報を更新する
   *  `expiresIn`によるトークンの有効期限を判定する
   */
  set(data: ITokenModel | null): boolean;

  /**
   * トークン情報を取得する
   */
  get<T extends ITokenModel>(type?: any): T;

  /**
   * トークン情報をクリアする
   */
  clear(options?: { onlyToken: boolean }): void;

  /**
   * トークン情報の更新イベントをサブスクライブする
   */
  change(): Observable<ITokenModel | null>;
}
